export default "__VITE_ASSET__BKlrgnWf__"